import { createStoreForProduct } from './ProductStore'

export const HighwayDiscussionStore = createStoreForProduct('highwaydiscussion')
